<template>
  <div class="loginFrom">
    <div class="logo-text">
      <div class="title">
        慧业智能·非金属矿物制品业工业互联网平台
      </div>
      <div class="entitle">
        运营管理系统
      </div>
    </div>
    <el-form ref="form" :model="formData" label-position="left" :rules="rules" hide-required-asterisk="true"
      class="loginfrom">
      <el-form-item prop="act">
        <el-input v-model="formData.act" @keyup.enter.native="login()" placeholder="用户名/账户名"><img slot="prefix"
            src="../../../assets/login_images/user.png" /></el-input>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input v-model="formData.pwd" show-password @keyup.enter.native="login()" placeholder="密码"><img slot="prefix"
            src="../../../assets/login_images/password.png" /></el-input>
      </el-form-item>
      <el-form-item>
        <template>
          <div class="flex">
            <el-input v-model="formData.yzCode" style="width: calc(100% - 100px)" @keyup.enter.native="login()"
              placeholder="验证码"><img slot="prefix" src="../../../assets/login_images/code.png" /></el-input>
            <canvas ref="canvas" width="100" height="40" @click="$draw(vfCode, $refs.canvas)"></canvas>
          </div>
        </template>
      </el-form-item>
      <el-button type="primary" class="loginBtn" @click="login()">登录</el-button>
      <el-form-item class="mt-15" label-width="0px">
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "login",
  mounted() {
    this.$draw(this.vfCode, this.$refs.canvas);
    axios.post('/Login/init')
  },
  data() {
    return {
      rules: {
        act: [
          {
            required: true,
            message: '用户名不能为空',
            trigger: 'blur',
          },
        ],
        pwd: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '请输入正确的验证码',
            trigger: 'blur',
          },
        ],
      },
      vfCode: [],
      formData: {
        act: "",
        pwd: "",
        yzCode: "",
      },
    };
  },
  methods: {
    keyUp(e) {
      console.log(e);
    },

    login() {
      this.$refs.form
        .validate()
        .then(() => {
          if (this.formData.yzCode.toUpperCase() == this.vfCode.join("").toUpperCase()) {
            this.$OL("登陆中...");
            this.$api
              .login({
                username: this.formData.act,
                password: this.formData.pwd,
              })
              .then((res) => {
                this.$CL();
                this.$setCK("token", res.data.data.token);
                this.$setCK("user", JSON.stringify(res.data.data));
                // 保存当前角色层级
                this.$api.loginGetLevelOfCurrentRole().then((res) => {
                  this.$setCK("userInfo", JSON.stringify(res.data.data));
                  // 保存权限集合
                  this.$api.getPermissions().then((res) => {
                    this.$setCK("r", JSON.parse(JSON.stringify(res.data.data))); // 权限集合
                    this.$router.push({
                      path: "/home",
                    });
                  });
                });
              });
          } else {
            this.$wMsg("验证码错误");
          }
        })
        .catch(() => {
          $wMsg("请填写完整信息");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 42px auto;

  .title {
    font-size: 20px;
  }

  .entitle {
    font-size: 32px;
    margin-top: 16px;
  }
}



.loginfrom {
  margin: 0 auto;
  width: 390px;

  ::v-deep .el-input__prefix {
    display: flex;
    align-items: center;
  }

  img {
    width: 20px;
    height: 20px;
  }

  .loginBtn {
    width: 100%;
    height: 58px;
    background: #3F75FF;
    border-radius: 6px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
  }
}
</style>
